import { useContext } from "react";

import dynamic from "next/dynamic";

import { FrontendTicketingContext } from "@/contexts/FrontendTicketingContext";
import { TicketingFrontendPageOutput } from "@/types/trpc";

const TicketingFormV2Page = dynamic(() =>
  import("@/components/TicketingFormV2Page/TicketingFormV2Page").then((mod) => mod.TicketingFormV2Page)
);
const TicketingContainerV1 = dynamic(() => import("./TicketingContainerV1").then((mod) => mod.TicketingContainerV1));

type TicketingVersionSelectorProps = {
  isSmallSize?: boolean;
  isFullWidth?: boolean;
  hideHeader?: boolean;
  isEmbed?: boolean;
  ssrTicketing: TicketingFrontendPageOutput;
  forceV2?: boolean;
};

export const TicketingVersionSelector: React.FunctionComponent<
  React.PropsWithChildren<TicketingVersionSelectorProps>
> = ({ isSmallSize, isFullWidth, hideHeader, ssrTicketing, isEmbed }) => {
  const { isCampaignRegistration, ticketing } = useContext(FrontendTicketingContext);

  if (isCampaignRegistration && ticketing.createdAtUtc && new Date(ticketing.createdAtUtc) < new Date("2025-09-21")) {
    return (
      <TicketingContainerV1
        ssrTicketing={ssrTicketing}
        isSmallSize={isSmallSize}
        isFullWidth={isFullWidth}
        hideHeader={hideHeader}
        isEmbed={isEmbed}
      />
    );
  }

  return <TicketingFormV2Page data={ssrTicketing} isEmbed={isEmbed} />;
};
